import * as React from 'react';

interface ILoader {
    isLoaderOn:boolean;
}

interface ILoaderAction {
    setLoader: (setLoader:boolean)=> void;
}

export const LoaderContext = React.createContext<ILoader>({
    isLoaderOn: false,
});

export const LoaderActionContext = React.createContext<ILoaderAction>({
    setLoader: (setLoader:boolean)=> {return setLoader}
});

const LoaderContextProvider = (props) => {
    const [isLoaderOn, setLoader] = React.useState(false);

    return (
      <LoaderContext.Provider value={{isLoaderOn}}>
          <LoaderActionContext.Provider value={({setLoader})} >
            {props.children}
        </LoaderActionContext.Provider>
      </LoaderContext.Provider>
    )
  };

export default LoaderContextProvider
